<template>
        <div class="full-page">
            <div class="skip-to-main-container">
                <a href="#main" class="skip-to-main-link cr-p2" data-testing="page-skip-to-main">{{ t('PAGE_SKIP_TO_MAIN_CONTENT') }}</a>
            </div>
            <Header/>
            <AcceptAgreementsDialog v-if="isLogin" @cancel="onAgreementCanceled()"/>
            <main class="main-content">
                <router-view></router-view>
            </main>
            <div class="notification-area" data-testing="notification-area">
                <cr-toast class="cr-mt3 cr-mb0 notification" v-for="notification in notifications" :key="notification.key" data-testing="notification" >{{ notification.message }}</cr-toast >
            </div>
            <Footer/>
            <error-dialog />
            <info-dialog />
            <cr-announcer/>
        </div>
</template>

<style scoped>  
.skip-to-main-container {
    position: absolute;
    width: 100vw;
    display: flex;
    justify-content: space-around;
}
.skip-to-main-link
{
    position: absolute;
    height: 2rem;
    background: var(--cr-primary);
    color: var(--cr-primary-text);
    transform: translateY(-100%);
    transition: transform 0.4s;
    z-index: 10;
    text-decoration: none;
}
.skip-to-main-link:focus
{
    transform: translateY(0%);
}
.full-page
{
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  position: relative;
  overflow-x: hidden;
  /* The following allows nested conent to expand to 100% height of it's container when small and keeps the background inmage while scrolling when large */
  height: 0;
  overflow-y: auto;
}
.main-content
{
    flex: 1 0 auto;
    margin: 0 4.2% 1.5rem;
}
.notification-area
{
    background-color: none;
    position: fixed;
    bottom: 1.5rem;
    right: 1.5rem;
    width: 16rem;
    z-index: 2000; /** appear in front of dialog backdrops */
}
.notification
{
    color: black;
}
/* Theme */
.comicbook .full-page {
    border: 22px solid white;
    outline: 2px solid black;
    outline-offset: -22px;
}
</style>

<script setup lang="ts">
import {  computed } from 'vue';
import { useAuthenticationStore } from '@stores/authenticationStore';
import { useCompetitionStore } from '@stores/competitionStore';
import { usePageTitle } from '@composables/usePageTitle';
import Config from "@/config";
import Route from "@/interfaces/route";
import { useRoute, useRouter } from 'vue-router';
import { useI18n } from 'vue-i18n';
import { useNotificationStore } from "@/stores/notificationStore";
import { storeToRefs } from 'pinia';

const { notifications } = storeToRefs(useNotificationStore());

const { t } = useI18n();
const route = useRoute();
const router = useRouter();

const isLogin = computed(() => useAuthenticationStore().isLogin);

const onAgreementCanceled = async (): Promise<void> => {
    await useAuthenticationStore().logout({
        redirect: true,
        reload: route.name === Route.Competitions.name,
        router: router
    });
};

const competitionName = useCompetitionStore().currentCompetition?.name;
const appTitle = competitionName ? `${competitionName} | ${Config.APP_TITLE}` : Config.APP_TITLE;
usePageTitle(appTitle);
</script>
